// src/events/trade/provider.ts
import { BaseEvent } from "@/domain/event";
import { EventViewModel } from "@/event-core/types";
import { fetchNormalEventDetail } from "./api";

export async function normalViewModelProvider( event: BaseEvent ): Promise<EventViewModel> {
    const { eventData, guessList } = await fetchNormalEventDetail( event.eventNo );
    return { eventCategory: event.eventCategory, eventNo: event.eventNo, eventData, guessList };
}
